/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { OverlayRef } from '@angular/cdk/overlay';

const OVERLAY_TOP_Z_INDEX = '9999';

/**
 * This method is necessary to place overlay over other overlays.
 * In future {@link #OverlayConfig} will have zIndex property. But now we have to use the trick used by this method.
 *
 * Note!!! This method must be called after component is attached to the overlay using
 * {@link PositionStrategy#apply} method (because this method can move overlayElement from one container to another).
 *
 * @param overlay
 */
export function liftOverlayOnTop(overlay: OverlayRef): void {
  let el = overlay.overlayElement;

  // udpate zIndex CSS property of overlay element and all its ancestors
  do {
    el.style.zIndex = OVERLAY_TOP_Z_INDEX;
    if (el.parentElement) {
      el = el.parentElement;
    }
  } while (el.tagName !== 'BODY');
}
